import React, { Fragment } from 'react'
import { Box, Button, Typography } from '@mui/material'
import Grid from '@mui/material/Grid2'
import CustomAlert from '../../_WMS/AlertMessage/AlertMessage'
import { RelatedAsnInfoDto } from '../types'

export interface RelatedAsnSelectorProps {
  /** Asn generadas por el quiebre de una devolución de marca mixta (INT/EXT) */
  relatedAsns: RelatedAsnInfoDto[]
  /** Asn sobre la que se está haciendo el control de calidad */
  activeAsnId: number
  onSelectAsn: (asn: RelatedAsnInfoDto) => void
}

// Informa que la devolución generó Asn relacionadas y permite alternar entre
// ellas para controlar cada una. No se renderiza cuando la devolución generó
// una sola Asn.
export const RelatedAsnSelector: React.FC<RelatedAsnSelectorProps> = ({
  relatedAsns,
  activeAsnId,
  onSelectAsn
}) => {
  if (relatedAsns.length <= 1) return <Fragment></Fragment>

  const asnNumbers = relatedAsns.map(({ asnNumber }) => asnNumber).join(' y ')

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12 }}>
        <CustomAlert
          severity='info'
          title='Esta devolución generó Asn relacionadas'
          message={`Se crearon ${relatedAsns.length} Asn por tipo de almacenamiento: ${asnNumbers}. Ambas quedaron recepcionadas y debe controlar cada una.`}
        />
      </Grid>
      <Grid size={{ xs: 12 }}>
        <Box display='flex' alignItems='center' style={{ gap: 8 }}>
          <Typography variant='body2'>Controlando:</Typography>
          {relatedAsns.map((asn) => (
            <Button
              key={asn.asnId}
              variant={asn.asnId === activeAsnId ? 'contained' : 'outlined'}
              color='primary'
              size='small'
              onClick={() => onSelectAsn(asn)}
            >
              {asn.asnNumber}
            </Button>
          ))}
        </Box>
      </Grid>
    </Grid>
  )
}